import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getHeatmapActivitySentimentOptions = async (activityId) => {
    const { data } = await vlqrApi.get(`FocusGroupHeatmapActivities/${activityId}/heatmapSentimentOptions`)
        .catch((error) => {
            handleError(error);
        });
    return data;
};

const getHeatmapSentimentOptionsForCrossSessionActivity = async (activityCrossSessionId) => {
    const { data } = await vlqrApi.get(`/FocusGroupHeatmapActivities/crossSession/${activityCrossSessionId}/heatmapSentimentOptions`)
        .catch((error) => {
            handleError(error);
        });
    return data;
};

const useHeatmapSentimentOptionsForActivity = ({ activityId, crossSessionId }) => {
    const queryKey = [crossSessionId
        ? 'heatmapSentimentOptionsForCrossSessionActivity'
        : 'heatmapSentimentOptionsForActivity'];
    const queryKeyValue = crossSessionId ?? activityId;

    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: [queryKey, queryKeyValue],

        queryFn: () => crossSessionId
            ? getHeatmapSentimentOptionsForCrossSessionActivity(crossSessionId)
            : getHeatmapActivitySentimentOptions(activityId)
    });

    return { data, refetch, isLoading, isError };
};

export default useHeatmapSentimentOptionsForActivity;
